import agent, { mocked } from 'agent'
import { all, call } from 'redux-saga/effects'
import appMode from 'helpers/getAppMode'

export function* getDomainVisibility(domainId, filters) {
  const visibility = yield call(
    appMode.share
      ? agent.Share.visibility
      : appMode.preview
      ? mocked.Domains.visibility
      : agent.Domains.visibility,
    domainId,
    filters
  )
  const visibilityChart = visibility.data.map(item => item.attributes)
  return visibilityChart
}

export function* getDomainOverview(domainId, filters) {
  const overview = yield call(
    appMode.share
      ? agent.Share.overview
      : appMode.preview
      ? mocked.Domains.overview
      : agent.Domains.overview,
    domainId,
    filters
  )
  return overview.data
}

export function* getDomainAveragePosition(domainId, filters) {
  const averagePosition = yield call(
    appMode.share
      ? agent.Share.averagePosition
      : appMode.preview
      ? mocked.Domains.averagePosition
      : agent.Domains.averagePosition,
    domainId,
    filters
  )
  const averageRankChart = averagePosition.data.map(item => item.attributes)
  return averageRankChart
}

export function* getDomainTraffic(domainId, filters) {
  const traffic = yield call(
    appMode.share
      ? agent.Share.traffic
      : appMode.preview
      ? mocked.Domains.traffic
      : agent.Domains.traffic,
    domainId,
    filters
  )
  const trafficChart = traffic.data.map(item => item.attributes)
  return trafficChart
}

export function* getDomainPosition(domainId, filters) {
  const position = yield call(
    appMode.share
      ? agent.Share.position
      : appMode.preview
      ? mocked.Domains.position
      : agent.Domains.position,
    domainId,
    filters
  )
  const positionChart = position.data.map(item => item.attributes)
  return positionChart
}

export function* getDomainSavingsChart(domainId, filters) {
  const savings = yield call(
    appMode.share
      ? agent.Share.savingsChart
      : appMode.preview
      ? mocked.Domains.savingsChart
      : agent.Domains.savingsChart,
    domainId,
    filters
  )
  const savingsChart = savings.data.map(item => item.attributes)
  return savingsChart
}

export function* getDomainSerpFeatureChart(domainId, filters) {
  const [serpFeatureChart, serpFeature] = yield all([
    call(
      appMode.share
        ? agent.Share.serpFeatureChart
        : appMode.preview
        ? mocked.Domains.serpFeatureChart
        : agent.Domains.serpFeatureChart,
      domainId,
      filters
    ),
    call(
      appMode.share
        ? agent.Share.serpFeature
        : appMode.preview
        ? mocked.Domains.serpFeature
        : agent.Domains.serpFeature,
      domainId,
      filters
    )
  ])
  const tracked = serpFeature.data.attributes.tracked
  const nonTracked = serpFeature.data.attributes.nonTracked
  const nonTrackedChart = serpFeatureChart.data.map(item => ({
    serpFeatures: item.attributes.nonTrackedSerpFeatures,
    date: item.attributes.date
  }))

  const trackedChart = serpFeatureChart.data.map(item => ({
    availableSerpFeatures: item.attributes.availableSerpFeatures,
    ownedSerpFeatures: item.attributes.ownedSerpFeatures,
    date: item.attributes.date
  }))

  return {
    nonTrackedChart,
    trackedChart,
    tracked,
    nonTracked
  }
}
